import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScreenSpinnerService } from '../../services/screen-spinner.service';

@Component({
  selector: 'lib-screen-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './screen-spinner.component.html',
  styleUrls: ['./screen-spinner.component.scss'],
})
export class ScreenSpinnerComponent {
  spinnerId = input.required<string>();
  private _screenSpinnerService: ScreenSpinnerService = inject(ScreenSpinnerService);

  isVisible = computed(() => this._screenSpinnerService.isVisible(this.spinnerId())());
}
